import { useToolbarContext } from './useToolbarContext'

export function useSelectedRecordsActionsState() {
    const { deleteRecordsSelected, recordsSelectedCount } = useToolbarContext()

    const buttonLabel = formatRecordCount(recordsSelectedCount)

    return {
        buttonLabel,
        deleteRecordsSelected,
    }
}

function formatRecordCount(count: number) {
    return count === 1 ? 'Delete record' : `Delete ${count} records`
}
